import React from 'react';

export const FaceSmilingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M11 16C11 17.1046 9.65685 18 8 18C6.34315 18 5 17.1046 5 16C5 14.8954 6.34315 14 8 14C9.65685 14 11 14.8954 11 16Z"
        fill="#FF6723"
      />
      <path
        d="M27 16C27 17.1046 25.6569 18 24 18C22.3431 18 21 17.1046 21 16C21 14.8954 22.3431 14 24 14C25.6569 14 27 14.8954 27 16Z"
        fill="#FF6723"
      />
      <path
        d="M8.98156 12.1909C9.02964 11.9436 9.13971 11.6405 9.34896 11.4125C9.52829 11.2171 9.84698 11 10.4999 11C11.1417 11 11.4685 11.2216 11.6572 11.4288C11.8753 11.6683 11.9804 11.9737 12.0147 12.1711C12.1092 12.7152 12.6269 13.0797 13.171 12.9853C13.7152 12.8908 14.0797 12.373 13.9852 11.8289C13.9062 11.374 13.6799 10.6794 13.1357 10.082C12.562 9.45218 11.6955 9 10.4999 9C9.31564 9 8.45269 9.4313 7.87551 10.0601C7.32826 10.6564 7.10696 11.3533 7.01833 11.8091C6.91291 12.3513 7.26694 12.8762 7.80907 12.9816C8.3512 13.087 8.87614 12.733 8.98156 12.1909Z"
        fill="#402A32"
      />
      <path
        d="M19.9818 12.1909C20.0299 11.9436 20.14 11.6405 20.3492 11.4125C20.5285 11.2171 20.8472 11 21.5002 11C22.1419 11 22.4687 11.2216 22.6574 11.4288C22.8756 11.6683 22.9807 11.9737 23.0149 12.1711C23.1094 12.7152 23.6271 13.0797 24.1713 12.9853C24.7154 12.8908 25.0799 12.373 24.9854 11.8289C24.9064 11.374 24.6802 10.6794 24.1359 10.082C23.5623 9.45218 22.6957 9 21.5002 9C20.3159 9 19.4529 9.4313 18.8758 10.0601C18.3285 10.6564 18.1072 11.3533 18.0186 11.8091C17.9132 12.3513 18.2672 12.8762 18.8093 12.9816C19.3514 13.087 19.8764 12.733 19.9818 12.1909Z"
        fill="#402A32"
      />
      <path
        d="M9.40006 18.2001C9.84189 17.8687 10.4687 17.9582 10.8001 18.4001C11.1415 18.8553 12.8621 20.5001 16.0001 20.5001C19.1381 20.5001 20.8586 18.8553 21.2001 18.4001C21.5314 17.9582 22.1582 17.8687 22.6001 18.2001C23.0419 18.5314 23.1314 19.1582 22.8001 19.6001C22.1415 20.4782 19.8621 22.5001 16.0001 22.5001C12.1381 22.5001 9.85864 20.4782 9.20006 19.6001C8.86869 19.1582 8.95823 18.5314 9.40006 18.2001Z"
        fill="#402A32"
      />
    </svg>
  );
};
